
import React, { useRef, useState } from 'react';
import { Space, Modal, Row, Col, Image } from "antd";
import { Button } from "@mui/material";
// import { MediumFont, NormalFont } from "../../../../../Shared/components/font";
// import jsPDF from 'jspdf';
// import clsx from "clsx";
import CloseIcon from "../../../../../../assets/images/icon_menus/Close Button.svg";
import { CheckListDetailed, CheckListSummary, DeliveryChallan, InvoiceChallan } from "./PrintBlocks";
// import Artboard from "../../../../../../assets/images/currency/Artboard.png";
import html2pdf from "html2pdf.js";
import Box from "../../../../../../assets/images/Box.png";


export const PrintDetails = (props) => {
    const { form, visible, classes, clsx, handleClose } = props;
    const printComponent = useRef(null);
    const [loading, setLoading] = useState(false);
    const formatRef = useRef(null);

    const handleDownload = (type = 'download') => {
        setLoading(true);
        const element = printComponent.current;
        const fullWidth = element.scrollWidth;
        html2pdf()
            .from(element)
            .set({
                margin: [10, 5, 10, 5], // [top, left, bottom, right]
                filename: "download.pdf",
                autoPaging: 'text',
                image: { type: "jpeg", quality: 1.0 },
                html2canvas: {
                    scale: 1, // Increase scale for high resolution
                    dpi: 300, // Ensure high DPI
                    useCORS: true,
                    letterRendering: true,
                    windowWidth: fullWidth,
                }, // A4 width in pixels (≈ 210mm)
                pagebreak: { mode: ["css", "legacy"], before: '.page-break', avoid: '.no-break' },
                jsPDF: { unit: "mm", format: 'a3', orientation: "portrait", compressPDF: true },
            }).toPdf().get("pdf").then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();

                    pdf.addImage(Box, "PNG", 5, 15, pageWidth - 10, pageHeight - 25);
                    
                    pdf.setFontSize(10);
                    pdf.setTextColor(49, 119, 135);
                    pdf.text('* Powered by YOUNOTE', 5, pageHeight - 5);
                }


                if (type === 'print') {
                    pdf.autoPrint();
                    window.open(pdf.output('bloburl', "_blank"));
                } else {
                    pdf.save(`delivery-details`);
                }
                setLoading(false);
            });
    };


    return (
        <Modal title="" open={visible} footer={null}
            onCancel={() => handleClose(!visible)}
            width={1030}
            closable={false}
            className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={24} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Space size={[20, 20]} direction="horizontal" align="center">
                        <Button
                            key="confirm"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload('print')}
                            className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}
                        >Print</Button>
                        <Button
                            key="save"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload()}
                            className={clsx(classes.modalBtn, { [classes.loading]: loading })}
                        >Download</Button>
                        <Image onClick={() => handleClose(!visible)} src={CloseIcon} preview={false} className={classes.cursor} />
                    </Space>
                </Col>
            </Row>
            <div ref={printComponent} className={clsx('divToPrint')} style={{ position: "relative", fontFamily: "Roboto" }}>
                {
                    form?.type === 'checkList' ? <>
                        {
                            form?.checkList === 'detailed' ?
                                <CheckListDetailed {...props} /> : <CheckListSummary  {...props} />
                        }
                    </> : form?.type === 'delivery' ? <DeliveryChallan {...props} /> : <InvoiceChallan ref={formatRef} {...props} />
                }
            </div>
        </Modal>
    )
}